/* global locales */
import angular from 'angular';
import 'angular-bootstrap';
import locales from '../../locale';
import './bannersServices';

function changeOrderResponse(data, key1, key2) {
    'use strict';
    if (!Array.isArray(data) || data.length <= Math.max(key1, key2)) {
        return data;
    }

    const temp = data[key1];
    data[key1] = data[key2];
    data[key2] = temp;

    if ('order' in data[key1] && 'order' in data[key2]) {
        const tempOrder = data[key1].order;
        data[key1].order = data[key2].order;
        data[key2].order = tempOrder;
    }

    return data;
}

const bannersControllers = angular.module('applicationModule.bannersControllers', ['applicationModule.bannersServices', 'ui.bootstrap']);

// Banners List Controller
bannersControllers.controller('BannersController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Banners', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, Banners, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('banners');
    $scope.application_id = $stateParams.application_id;
    $scope.placements = [];
    $scope.placementLabels = [];
    $scope.client_url = null;
    $scope.package_id = null;
    $scope.checkedBanners = [];
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Banners.getList($scope.application_id, params._params)
                .then(function (response) {
                    $scope.placements = response.placements;
                    $scope.client_url = response.client_url;
                    $scope.package_id = response.package_id;
                    $scope.placementLabels = response.placement_labels;
                    params.total(response.banners.total);
                    params.count(response.banners.per_page);
                    params.page(response.banners.current_page);
                    if (angular.isDefinedNotNull($stateParams.searchBanners)) {
                        $scope.search = $stateParams.searchBanners;
                        $scope.searchBanners($scope.search);
                    }
                    return response.banners.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    Banners.create($scope.application_id)
        .then(function (response) {
            const data = response.data;
            if (data.success) {
                angular.forEach(data.placements, function (value) {
                    $scope.placements[value.value] = value;
                });
            }
        });

    $scope.newBanner = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/banners/banner.tpl.html',
            controller: 'BannerModalController',
            resolve: {
                banner: function () {
                    return {
                        app_id: $scope.application_id
                    };
                }
            }
        });
        modalInstance.result.then(function (banner) {
            if (!$scope.tableParams.data) {
                $scope.tableParams.data = [];
            }
            $scope.tableParams.data.push(banner);
            growl.success('MODULES.BANNERS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editBanner = function (data, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/banners/banner.tpl.html',
            controller: 'BannerModalController',
            resolve: {
                banner: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (banner) {
            $scope.tableParams.data[index] = banner;
            growl.success('MODULES.BANNERS.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.selectBanner = function (id) {
        $scope.checkedBanners = angular.selectElement($scope.checkedBanners, id);

        if ($scope.checkedBanners.length < 1) {
            $scope.clearAction();
        }
    };

    $scope.selectAllBanners = function () {
        const data = $scope.tableParams.data || [];
        const allIds = data.map(item => item.id);
        const allSelected = allIds.every(id => $scope.checkedBanners.includes(id));

        $scope.checkedBanners = allSelected ? [] : allIds;
    };

    $scope.selectBanner = function (id) {
        const index = $scope.checkedBanners.indexOf(id);
        if (index === -1) {
            $scope.checkedBanners.push(id);
        } else {
            $scope.checkedBanners.splice(index, 1);
        }

        if ($scope.checkedBanners.length < 1) {
            $scope.clearAction();
        }
    };

    $scope.removeBanner = function (id, index) {
        Banners.remove(id, $scope.application_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.BANNERS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.BANNERS.ERROR.DELETED');
                }
            });
    };

    $scope.copyBanners = function (id) {
        Banners.copy(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.BANNERS.SUCCESS.COPIED');
                $state.go($state.current, {searchBanners: $stateParams.searchBanners}, {reload: true});
            } else {
                const message = data.error === 'ERROR.BANNER_NOT_EXISTS' ? 'MODULES.BANNERS.ERROR.BANNER_NOT_EXISTS' : 'MODULES.BANNERS.ERROR.COPIED';
                growl.error(message);
            }
        });
    };

    $scope.removeBanners = function () {
        angular.forEach($scope.checkedBanners, function (val) {
            angular.forEach($scope.tableParams.data, function (v, k) {
                if (val === v.id) {
                    $scope.tableParams.data.splice(k, 1);
                }
            });
        });
        Banners.removeChecked($scope.checkedBanners, $scope.application_id).then(function (response) {
            const data = response.data;
            if (!data.success) {
                growl.error('MODULES.BANNERS.ERROR.DELETED_BANNERS');
            }
        });
        growl.success('MODULES.BANNERS.SUCCESS.DELETED_BANNERS');
        $scope.checkedBanners = [];
    };

    $scope.clearAction = function () {
        $scope.searchedCategories = [];
    };

    $scope.searchBanners = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.placement)) {
            $scope.tableParams._params.placement = undefined;
        }
        $scope.search = {};
        delete $scope.tableParams._params.name;
        delete $scope.tableParams._params.placement;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });

    }, true);

}]);

// Banner Modal Controller
bannersControllers.controller('BannerModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Banners', 'banner', function ($scope, $state, $stateParams, $modalInstance, growl, Banners, banner) {
    'use strict';
    const appId = $stateParams.application_id;
    $scope.banner = {};
    $scope.banner.application_id = appId;
    $scope.editMode = false;

    if (banner.name) {
        $scope.editMode = true;
        $scope.banner = angular.copy(banner);
    }

    $scope.placements = [];

    Banners.create(appId)
        .then(function (response) {
            if (response.data.success) {
                $scope.placements = response.data.placements;
            }
        });

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.bannerForm.$valid) {
            $scope.isLoading = true;

            Banners.save($scope.banner, $scope.editMode)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        $modalInstance.close(data.banner);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.BANNERS.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        } else {
            growl.error('GROWL.ERROR.REQUIRE.ALL');
        }

    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
        'placement': [{type: '$invalid', msg: 'ERROR.REQUIRE.PLACEMENT'}]
    };
}]);

// Banner Elements List Controller
bannersControllers.controller('BannerElementsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'BannerElements', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', 'Banners', function ($scope, $rootScope, $stateParams, NgTableParams, BannerElements, growl, AppsoupAPI, Permissions, $state, $modal, Banners) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('banners');
    $scope.application_id = $stateParams.application_id;
    $scope.banner_id = $stateParams.bannerId;
    $scope.banner = {};
    $scope.bannerTitle = [];
    $scope.data_element = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return BannerElements.getList($scope.application_id, $scope.banner_id, params._params).then(function (data) {
                const response = data.data;
                params.total(response.elements.total);
                params.count(response.elements.per_page);
                params.page(response.elements.current_page);
                $scope.package_id = response.package_id;
                $scope.client_url = response.client_url;
                return response.elements.data;
            }).catch(function () {
                $state.go('appsoup.application.banners');
                growl.error('ERROR.EMPTY_DATA');
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    Banners.get($stateParams.bannerId, $stateParams.application_id).then(function (response) {
        const data = response.data;
        if (data.success) {
            $scope.banner = data.banner;
            $scope.bannerTitle.push('(' + $scope.banner.name + ')');
        }
    });

    $scope.newElement = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/banners/element.tpl.html',
            controller: 'BannerElementModalController',
            resolve: {
                element: function () {
                    return {
                        app_id: $scope.application_id,
                        banner_id: $scope.banner_id,
                        package_id: $scope.package_id
                    };
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data.push(element);
            growl.success('MODULES.BANNERS.ELEMENTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editElement = function (data, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/banners/element.tpl.html',
            controller: 'BannerElementModalController',
            resolve: {
                element: function () {
                    return Object.assign(data, {package_id: $scope.package_id});
                }
            }
        });
        modalInstance.result.then(function (element) {
            BannerElements.get(element.id, $scope.application_id).then(function (data_element) {
                if (data_element.success) {
                    $scope.data_element = data_element.element;
                    $scope.tableParams.data[index] = $scope.data_element;
                }
            });
            growl.success('MODULES.BANNERS.ELEMENTS.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeElement = function (id, index) {
        BannerElements.remove(id, $scope.application_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.BANNERS.ELEMENTS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.BANNERS.ELEMENTS.ERROR.DELETED');
                }
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        var data = $scope.tableParams.data;
        $event.stopImmediatePropagation();
        BannerElements.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            application_id: $scope.application_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = changeOrderResponse(data, key1, key2);
                }
            });
        $scope.tableParams.data = data;
    };

    $scope.changeOrderExtreme = function ($event, key1, direction) {
        $event.stopImmediatePropagation();

        const data = $scope.tableParams.data;
        $scope.tableParams.data = changeOrderExtreme(data, key1, direction);

        BannerElements.changeOrderExtreme({
            data: data,
            application_id: $scope.application_id
        });
    };
}]);

// Banner Element Modal Controller
bannersControllers.controller('BannerElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'BannerElements', 'element', '$filter', '$locale', function ($scope, $state, $stateParams, $modalInstance, growl, BannerElements, element, $filter, $locale) {
    'use strict';
    const appId = $stateParams.application_id;
    $scope.element = {};
    $scope.element.app_id = appId;
    $scope.element.banner_id = element.banner_id;
    $scope.package_id = element.package_id;
    $scope.editMode = false;
    $scope.upload = undefined;
    $scope.uploadGroups = undefined;
    $scope.fileUploaded = false;
    $scope.fileUploadedGroups = false;
    $scope.fileName = undefined;
    $scope.fileNameGroups = undefined;
    $scope.date = new Date();
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang]) {
        angular.extend($locale.DATETIME_FORMATS, locales[$scope.lang].DATETIME_FORMATS || {});
        angular.extend($locale.NUMBER_FORMATS, locales[$scope.lang].NUMBER_FORMATS || {});
    }
    $scope.genders = [
        {key: 'GENDER.ANY', value: null},
        {key: 'GENDER.FEMALE', value: 'female'},
        {key: 'GENDER.MALE', value: 'male'}
    ];

    $scope.time_to = false;
    $scope.time_from = false;

    $scope.element.time_to = $filter('date')($scope.date.getTime(), 'yyyy-MM-dd');
    $scope.element.time_from = $filter('date')($scope.date.getTime(), 'yyyy-MM-dd');

    if (element.title) {
        $scope.editMode = true;
        $scope.element = angular.copy(element);
        $scope.element.time_to = $filter('date')(element.time_to, 'yyyy-MM-dd');
        $scope.element.time_from = $filter('date')(element.time_from, 'yyyy-MM-dd');
        if (angular.isDefined($scope.element.products_info) && angular.isDefined($scope.element.products_info.file_name)) {
            $scope.fileName = $scope.element.products_info.file_name;
            $scope.fileUploaded = true;
        }
        if (angular.isDefined($scope.element.groups_info) && angular.isDefined($scope.element.groups_info.file_name)) {
            $scope.fileNameGroups = $scope.element.groups_info.file_name;
            $scope.fileUploadedGroups = true;
        }
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.elementForm.$valid) {
            $scope.isLoading = true;
            var temp = [];
            angular.forEach($scope.element.tags, function (v) {
                temp.push(v.trim());
            });
            $scope.element.tags = temp;

            BannerElements.save($scope.element, $scope.editMode, $scope.upload, $scope.uploadGroups)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        $modalInstance.close(data.element);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.BANNERS.ELEMENTS.ERROR.CREATED');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        } else {
            growl.error('GROWL.ERROR.REQUIRE.ALL');
        }

    };

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.fileName = undefined;
        $scope.element.products_info = [];
    };

    $scope.removeFileGroups = function () {
        $scope.uploadGroups = undefined;
        $scope.fileUploadedGroups = false;
        $scope.fileNameGroups = undefined;
        $scope.element.groups_info = [];
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.fileName = undefined;
        $scope.$apply();
    };

    $scope.uploadSuccessGroups = function (file) {
        $scope.uploadGroups = file;
        $scope.fileUploadedGroups = true;
        $scope.fileNameGroups = undefined;
        $scope.$apply();
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'ERROR.REQUIRE.TITLE'}],
        'image': [{error: 'required', msg: 'ERROR.REQUIRE.IMAGE'}, {
            error: 'pattern',
            msg: 'MODULES.BANNERS.ERROR.IMAGE'
        }],
        'deeplink': [{type: '$invalid', msg: 'ERROR.REQUIRE.DEEPLINK'}],
        'type': [{type: '$invalid', msg: 'ERROR.REQUIRE.TYPE'}],
        'duration': [{type: '$invalid', msg: 'ERROR.REQUIRE.DURATION'}],
        'time_from': [{type: '$invalid', msg: 'ERROR.REQUIRE.TIME_FROM'}],
        'time_to': [{type: '$invalid', msg: 'ERROR.REQUIRE.TIME_TO'}],
        'min_age': [{type: '$invalid', msg: 'ERROR.MIN_AGE_BIGGER_MAX'}]
    };
}]);

export default bannersControllers;
